import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Label, Input } from "reactstrap"
import Switch from "react-switch"
import VenueParking from "./parking/VenueParking"
import VenueSession from "./session/VenueSession"
import VenueFoodBooking from "./food/VenueFoodBooking"
import LayerGroupMap from "pages/Maps/LeafletMap/LayerGroup"
import { Map, Marker, GoogleApiWrapper } from "google-maps-react"
import VenueOrganizer from "../venue_organizer/VenueOrganizer"
import moment from "moment-timezone";

const VenueStep = ({
  validation,
  openSection,
  toggleSection,

  addParkingType,
  removeParkingType,
  addSession,
  removeSession,
  addFoodItem,
  removeFoodItem,
}) => {
  const handleLocationSelect = async (lat, lng) => {
    validation.setFieldValue("enable_google_map", true) // ensure map is enabled
    validation.setFieldValue("venue_google_map", {
      ...validation.values.venue_google_map,
      latitude: lat,
      longitude: lng,
    })

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
      )
      const data = await response.json()
      if (data?.display_name) {
        validation.setFieldValue("venue_google_map", {
          ...validation.values.venue_google_map,
          latitude: lat,
          longitude: lng,
          map_address: data.display_name,
        })
        validation.setFieldValue("address", data.display_name) // optional
      }
    } catch (error) {
      console.error("Reverse geocoding failed:", error)
    }
  }



 
const handleStartChange = (e) => {
  validation.setFieldValue("start_datetime", e.target.value);
};

const handleEndChange = (e) => {
  const value = e.target.value;
  const start = validation.values.start_datetime;

  if (start && value < start) return;

  validation.setFieldValue("end_datetime", value);
};

 

const formatForInput = (utcDate) => {
  if (!utcDate) return "";

  return moment(utcDate)
    .local() // convert to user's timezone
    .format("YYYY-MM-DDTHH:mm");
};
 
const minDateTime = moment().format("YYYY-MM-DDTHH:mm"); 
  useEffect(() => {
    if (validation.values.reserved_seat > validation.values.max_tickets) {
      validation.setFieldValue("reserved_seat", "")
    }
  }, [validation.values.max_tickets])
  return (
    <>

      {/* Section Header */}
      <div className="d-flex align-items-center mb-4">
        <div className="avatar-sm me-3">
          <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
            <i className="mdi mdi-map-marker"></i>
          </span>
        </div>
        <div>
          <h5 className="mb-0 fw-semibold">Venue Details</h5>
          <small className="text-muted">Set up your venue location and schedule</small>
        </div>
      </div>

      <Row className="gap-3 mb-4">
        <Col md={12} className="p-4 border border-primary rounded-3 bg-light">
          <Row className="gap-3">
            <Col md={12}>
              <Label className="form-label fw-medium">
                Venue Name <span className="text-danger">*</span>
              </Label>
              <Input
                name="venue"
                type="text"
                placeholder="Enter venue name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.venue}
                invalid={validation.touched.venue && validation.errors.venue}
                className="form-control"
              />
              {validation.touched.venue && validation.errors.venue && (
                <div className="text-danger small mt-1">{validation.errors.venue}</div>
              )}
            </Col>

            <Col md={12}>
              <Label className="form-label fw-medium">
                Venue Address <span className="text-danger">*</span>
              </Label>
              <Input
                name="address"
                type="text"
                placeholder="Enter full address"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.address}
                className="form-control"
              />
              {validation.touched.address && validation.errors.address && (
                <div className="text-danger small mt-1">{validation.errors.address}</div>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={4} className="d-flex align-items-end pb-1 mt-3 ">
              <div className="d-flex align-items-center gap-2 p-3 bg-light rounded-pill w-100">
                <Switch
                  onColor="#34c38f"
                  offColor="#b3a692"
                  checked={validation.values.enable_google_map}
                  onChange={checked => validation.setFieldValue("enable_google_map", checked)}
                  height={16}
                  width={32}
                  handleDiameter={14}
                  uncheckedIcon={false}
                  checkedIcon={false}
                />
                <Label className="mb-0 fw-medium" htmlFor="enable_google_map">
                  <i className="mdi mdi-map me-1 text-primary"></i>Enable Map
                </Label>
              </div>
            </Col>
          </Row>
          {validation.values.enable_google_map && (
            <Row className="mb-4 mt-2">
              <Col md={12}>
                <h6 className="mb-3 fw-semibold">
                  <i className="mdi mdi-crosshairs-gps me-2 text-primary"></i>Venue Location
                </h6>
                <div style={{ height: "150px", }} >
                  <VenueGoogleMap onLocationSelect={handleLocationSelect} />
                </div>
              </Col>
            </Row>
          )}
          <Row className={`${validation.values.enable_google_map ? "mt-5" : "mt-2"}`}>

            <Col md={4}>
              <Label className="form-label fw-medium">
                Event Start Date & Time <span className="text-danger">*</span>
              </Label>
              <Input
                name="start_datetime"
                type="datetime-local"
                min={minDateTime}
                // onChange={validation.handleChange}
                onChange={handleStartChange}
                onBlur={validation.handleBlur}
                // value={validation.values.start_datetime}
                //  value={formatForInput(validation.values.start_datetime)}
                value={validation.values.start_datetime || ""}
                invalid={validation.touched.start_datetime && validation.errors.start_datetime}
                className="form-control"
              />
              {validation.touched.start_datetime && validation.errors.start_datetime && (
                <div className="text-danger small mt-1">{validation.errors.start_datetime}</div>
              )}
            </Col>

            <Col md={4}>
              <Label className="form-label fw-medium">
                Event End Date & Time <span className="text-danger">*</span>
              </Label>
              <Input
                name="end_datetime"
                type="datetime-local"
                // min={validation.values.start_datetime || minDateTime}
                min={formatForInput(validation.values.start_datetime) || minDateTime}
                // onChange={e => {
                //   const endDate = e.target.value
                //   const startDate = validation.values.start_datetime
                //   if (startDate && new Date(endDate) < new Date(startDate)) return
                //   validation.setFieldValue("end_datetime", endDate)
                // }}
                onChange={handleEndChange}
                onBlur={validation.handleBlur}
                // value={validation.values.end_datetime}
                  // value={formatForInput(validation.values.end_datetime)}
                  value={validation.values.end_datetime || ""}

                invalid={validation.touched.end_datetime && validation.errors.end_datetime}
                className="form-control"
              />
              {validation.touched.end_datetime && validation.errors.end_datetime && (
                <div className="text-danger small mt-1">{validation.errors.end_datetime}</div>
              )}
            </Col>


          </Row>
        </Col>

        <Col md={12} className="p-4 border border-primary rounded-3 bg-light">
          <Row className="gap-4">
            <Col md={2}>
              <Label className="form-label fw-medium">
                Venue Capacity <span className="text-danger">*</span>
              </Label>
              <div className="input-group">
                <span className="input-group-text bg-light">
                  <i className="mdi mdi-account-group text-muted"></i>
                </span>
                <Input
                  name="max_tickets"
                  type="number"
                  placeholder="Total capacity"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.max_tickets}
                  className="form-control"
                />
              </div>
              {validation.touched.max_tickets && validation.errors.max_tickets && (
                <div className="text-danger small mt-1">{validation.errors.max_tickets}</div>
              )}
            </Col>
            <Col md={8}>
              <Row className="gap-3 align-items-center">
                <Col className="form-check form-switch mt-3 col-auto ">
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    id="reserved"
                    // style={{ width: 36, height: 20 }}
                    defaultChecked={validation.values.enable_reserved_seating}
                    onChange={e => validation.setFieldValue("enable_reserved_seating", e.target.checked)}
                  />
                  <Label className="fw-medium" htmlFor="reserved">Enable Reserved Seating</Label>
                </Col>
                {validation.values.enable_reserved_seating && (
                  <Col md={4} >
                    <Label className="form-label fw-medium">Reserved Count</Label>
                    <Input
                      type="number"
                      id="reservedCount"
                      name="reserved_seat"
                      placeholder="Enter reserved seats"
                      max={validation.values.max_tickets}
                      className={`form-control ${validation.errors.reserved_seat && validation.touched.reserved_seat ? "is-invalid" : ""}`}
                      value={validation.values.reserved_seat}
                      onChange={e => {
                        const value = Number(e.target.value)
                        const capacity = Number(validation.values.max_tickets)
                        if (!capacity || value <= capacity) {
                          validation.setFieldValue("reserved_seat", value)
                        }
                      }}
                      onBlur={validation.handleBlur}
                    />
                    {validation.errors.reserved_seat && validation.touched.reserved_seat && (
                      <div className="invalid-feedback">{validation.errors.reserved_seat}</div>
                    )}
                  </Col>
                )}
              </Row>
            </Col>

          </Row>
        </Col>

        <Col md={12} className="p-4 border border-primary rounded-3 bg-light">
          <VenueOrganizer validation={validation} />
        </Col>

        <Col md={12} className="p-4 border border-primary rounded-3 bg-light">
          <VenueParking
            validation={validation}
            toggleSection={toggleSection}
            openSection={openSection}
            addParkingType={addParkingType}
            removeParkingType={removeParkingType}
          />
        </Col>

        <Col md={12} className="p-4 border border-primary rounded-3 bg-light">
          <VenueSession
            validation={validation}
            toggleSection={toggleSection}
            openSection={openSection}
            addSession={addSession}
            removeSession={removeSession}
          />
        </Col>

        <Col md={12} className="p-4 border border-primary rounded-3 bg-light">
          <VenueFoodBooking
            validation={validation}
            toggleSection={toggleSection}
            openSection={openSection}
            addFoodItem={addFoodItem}
            removeFoodItem={removeFoodItem}
          />
        </Col>


      </Row>

    </>
  )
}

const VenueGoogleMapComponent = ({ google, onLocationSelect }) => {
  const [markerPosition, setMarkerPosition] = useState(null)

  const handleMapClick = (mapProps, map, clickEvent) => {
    const lat = clickEvent.latLng.lat()
    const lng = clickEvent.latLng.lng()

    setMarkerPosition({ lat, lng })

    if (onLocationSelect) {
      onLocationSelect(lat, lng)
    }
  }

  return (
    <Map
      google={google}
      zoom={13}
      style={{ width: "90%", height: "100%", position: "relative" }}
      initialCenter={{ lat: 13.0827, lng: 80.2707 }}
      onClick={handleMapClick}
    >
      {markerPosition && <Marker position={markerPosition} />}
    </Map>
  )
}

export const VenueGoogleMap = GoogleApiWrapper({
  apiKey: "AIzaSyBgjYcIeAbF4_JoqYVBqBqbL15YJX9HHiY",
})(VenueGoogleMapComponent)
export default VenueStep
